<div class="drawer-shell">
  <div class="drawer-header">
    <div>
      <h3 class="mb-1">User Scores</h3>
      <div class="user-meta" *ngIf="user">
        <div>{{ user.firstName }} {{ user.lastName }}</div>
        <div>{{ user.userId }}</div>
      </div>
    </div>
    <button mat-icon-button (click)="closeDrawer.emit()" aria-label="Close score drawer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="loading" class="drawer-state">
    <mat-spinner diameter="36"></mat-spinner>
    <p class="mt-3 mb-0 text-muted">Loading score sessions...</p>
  </div>

  <div *ngIf="!loading && errorMessage" class="alert alert-danger mb-0">
    {{ errorMessage }}
  </div>

  <div *ngIf="!loading && !errorMessage && user" class="attempt-access-card">
    <div>
      <h4>Assessment Attempt Access</h4>
      <p>This setting applies globally to the user, outside individual assessment sessions.</p>
    </div>
    <div class="attempt-access-actions">
      <mat-form-field appearance="outline" class="attempt-access-field">
        <mat-label>Attempt status</mat-label>
        <mat-select [(ngModel)]="assessmentAttemptBlockedDraft">
          <mat-option [value]="false">Allow Attempt</mat-option>
          <mat-option [value]="true">Blocked</mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-stroked-button
        color="primary"
        (click)="emitSaveAttemptAccess()"
        [disabled]="savingAttemptAccess">
        <mat-spinner *ngIf="savingAttemptAccess" diameter="16"></mat-spinner>
        <span *ngIf="!savingAttemptAccess">Save Access</span>
      </button>
    </div>
  </div>

  <div *ngIf="!loading && !errorMessage && !sessions.length" class="drawer-state">
    <mat-icon>assessment</mat-icon>
    <p class="mb-0 text-muted">No assessment sessions found for this user.</p>
  </div>

  <mat-accordion *ngIf="!loading && sessions.length" class="session-accordion">
    <mat-expansion-panel *ngFor="let session of sessions">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Session {{ session.sessionId }}
        </mat-panel-title>
        <mat-panel-description>
          {{ getDisplaySession(session).assessmentState || 'INPROGRESS' }}
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="session-grid">
        <div class="session-block">
          <div class="label">User Name</div>
          <div>{{ user?.firstName }} {{ user?.lastName }}</div>
        </div>

        <div class="session-block">
          <div class="label">User ID</div>
          <div>{{ session.userId }}</div>
        </div>

        <div class="session-block">
          <div class="label">Session ID</div>
          <div>{{ session.sessionId }}</div>
        </div>

        <div class="session-block">
          <div class="label">Assessment State</div>
          <mat-form-field appearance="outline" class="w-100 compact-field">
            <mat-select [(ngModel)]="stateDrafts[session.sessionId]">
              <mat-option *ngFor="let state of assessmentStateOptions" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button
            mat-stroked-button
            color="primary"
            (click)="emitSaveState(session.sessionId)"
            [disabled]="savingStateSessionId === session.sessionId">
            <mat-spinner *ngIf="savingStateSessionId === session.sessionId" diameter="16"></mat-spinner>
            <span *ngIf="savingStateSessionId !== session.sessionId">Save State</span>
          </button>
        </div>
      </div>

      <div class="section-header">
        <h4 class="mb-0">Levels</h4>
        <div class="action-row">
          <button
            mat-stroked-button
            color="primary"
            *ngIf="!isEditing(session.sessionId)"
            (click)="startEdit(session)">
            Edit Levels
          </button>
          <button
            mat-button
            *ngIf="isEditing(session.sessionId)"
            (click)="cancelEdit(session.sessionId)">
            Cancel
          </button>
          <button
            mat-raised-button
            color="primary"
            *ngIf="isEditing(session.sessionId)"
            (click)="emitSaveAssessment(session, 'UPDATE-OLD')"
            [disabled]="savingAssessmentSessionId === session.sessionId">
            Update Existing
          </button>
          <button
            mat-stroked-button
            color="accent"
            *ngIf="isEditing(session.sessionId)"
            (click)="emitSaveAssessment(session, 'CREATE-NEW')"
            [disabled]="savingAssessmentSessionId === session.sessionId">
            Create New Copy
          </button>
          <button
            mat-raised-button
            color="accent"
            *ngIf="isCompleted(session)"
            (click)="loadDashboard.emit(session)">
            Show Dashboard
          </button>
        </div>
      </div>

      <div class="levels-list">
        <div
          class="level-card cognitive-level-card"
          *ngFor="let levelEntry of getLevelEntries(session)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'View progression history for ' + levelEntry.key"
          (click)="openLevelHistory(levelEntry)"
          (keydown)="onLevelCardKeydown($event, levelEntry)"
        >
          <div class="level-title">{{ levelEntry.key }}</div>
          <div class="level-controls">
            <button
              mat-icon-button
              color="primary"
              *ngIf="isEditing(session.sessionId)"
              (click)="$event.stopPropagation(); adjustLevel(session, levelEntry.key, -1)">
              <mat-icon>remove</mat-icon>
            </button>
            <div class="level-value">{{ levelEntry.value.level ?? 0 }}</div>
            <button
              mat-icon-button
              color="primary"
              *ngIf="isEditing(session.sessionId)"
              (click)="$event.stopPropagation(); adjustLevel(session, levelEntry.key, 1)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <div class="level-meta">
            Type: {{ levelEntry.value.typeId || 'NA' }} | Attempted: {{ levelEntry.value.totalAttempted ?? 0 }}
          </div>
          <div class="history-link">
            <mat-icon>timeline</mat-icon>
            View history
          </div>
        </div>
      </div>

      <ng-container *ngIf="getBehavioralSelectionEntries(session) as behavioralEntries">
        <div class="behavioral-section" *ngIf="behavioralEntries.length > 0">
          <div class="section-header behavioral-header">
            <h4 class="mb-0">Behavioral Selections</h4>
          </div>

          <div class="levels-list">
            <div class="level-card behavioral-card" *ngFor="let behavioralEntry of behavioralEntries">
              <div class="level-title">{{ behavioralEntry.key }}</div>

              <div
                class="selection-values"
                *ngIf="getBehavioralSelections(behavioralEntry.value) as selections"
              >
                <ng-container *ngIf="selections.length > 0; else noBehavioralSelection">
                  <span class="selection-chip" *ngFor="let selection of selections">
                    Option {{ selection }}
                  </span>
                </ng-container>
                <ng-template #noBehavioralSelection>
                  <span class="empty-selection">No option selected</span>
                </ng-template>
              </div>

              <div class="level-meta">
                Type: {{ behavioralEntry.value.typeId || 'NA' }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="json-section">
        <h4>Score Object</h4>
        <pre>{{ getDisplaySession(session) | json }}</pre>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<ng-template #levelHistoryDialog>
  <div class="history-dialog" *ngIf="selectedLevelEntry as levelEntry">
    <div class="history-dialog-title" mat-dialog-title>
      <div>
        <span class="history-dialog-eyebrow">Level progression</span>
        <h2>{{ levelEntry.key }}</h2>
      </div>
      <button mat-icon-button mat-dialog-close aria-label="Close level history">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content>
      <div class="history-current-level">
        Current level <strong>{{ levelEntry.value.level ?? 0 }}</strong>
      </div>

      <ng-container *ngIf="levelEntry.value.history?.length; else noLevelHistory">
        <div class="history-timeline">
          <div class="history-item" *ngFor="let historyItem of levelEntry.value.history; let i = index">
            <div class="history-marker">
              <span>{{ i + 1 }}</span>
            </div>
            <div class="history-event">
              <div class="history-event-heading">
                <strong>Level {{ historyItem.level ?? 'NA' }}</strong>
                <span>Step {{ i + 1 }}</span>
              </div>
              <div class="history-stats">
                <div>
                  <span>Questions answered</span>
                  <strong>{{ historyItem.totalAttempted ?? 0 }}</strong>
                </div>
                <div>
                  <span>Correct answers</span>
                  <strong>{{ historyItem.correctAnswer ?? 0 }}</strong>
                </div>
                <div>
                  <span>Accuracy</span>
                  <strong>{{ historyItem.accuracy ?? 0 }}%</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noLevelHistory>
        <div class="empty-history">
          <mat-icon>history_toggle_off</mat-icon>
          <strong>No history available</strong>
          <span>This level does not have any recorded progression yet.</span>
        </div>
      </ng-template>
    </mat-dialog-content>
  </div>
</ng-template>
